import React, { Children, forwardRef } from 'react';
import classNames from 'classnames';
import { renderChildren } from '@fiverr-private/ui_utils';
import { Box } from '@fiverr-private/theme';
import { ListProps } from './types';
import { generateDefaultPadding } from './helpers';

const List = forwardRef<HTMLElement, ListProps>(({ children, className, ...restProps }: ListProps, ref) => {
  const childrenArray = Children.toArray(children);
  const listItemStyles = {
    display: 'flex',
    gap: '2',
  };

  return (
    <Box
      ref={ref}
      as="ul"
      listStyleType="none"
      className={classNames(generateDefaultPadding(restProps), className)}
      {...restProps}
    >
      {Children.map(children, (child, idx) =>
        renderChildren(
          child,
          idx === childrenArray.length - 1 ? listItemStyles : { ...listItemStyles, paddingBottom: '2' }
        )
      )}
    </Box>
  );
});

List.displayName = 'List';

export default List;
